import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    value: 1,
};

export const counterSlice = createSlice({
    name: "counter",
    initialState,
    reducers: {
        increment: (state) => {
            if (state.value >= 6) {
                state.value = 1;
            } else {
                state.value = state.value + 1;
            }
        },
        decrement: (state) => {
            if (state.value <= 1) {
                state.value = 6;
            } else {
                state.value = state.value - 1;
            }
        },
        resetCount: (state) => {
                state.value = 1;
        },
    },
});

// Action creators are generated for each case reducer function
export const { increment, decrement, resetCount } = counterSlice.actions;

export default counterSlice.reducer;